module.exports = __webpack_public_path__ + "static/img/8.fa2d3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8.jpg
// module id = 328
// module chunks = 0